<svg viewBox="-20 -20 740 740" xmlns="http://www.w3.org/2000/svg">
    <circle cx="350" cy="350" r="190" fill="white"/>
    <circle cx="350" cy="350" r="150" fill="#1E78E6"/>
</svg>
